import { Component, Input, OnChanges, SimpleChanges } from '@angular/core';
import { HttpService } from 'src/app/shared/services/http.service';
import { DeleteWarningComponent } from '../../delete-warning/delete-warning.component';
import { MatDialog } from '@angular/material/dialog';
import { AppService } from 'src/app/app.service';
import { ExcelToTableComponent } from '../../excel-to-table/excel-to-table.component';
import * as XLSX from 'xlsx';
import { TableService } from 'src/app/shared/services/tableService/table.service';
import {
  FIXED_FTL_order,
  FTL_order,
} from 'src/app/shared/interfaces/rate-information.interface';
import { Subject, take, takeUntil } from 'rxjs';

@Component({
  selector: 'app-fixed-ftl',
  standalone: false,
  templateUrl: './fixed-ftl.component.html',
  styleUrl: './fixed-ftl.component.scss',
})
export class FixedFtlComponent implements OnChanges {
  truckType = ['euro', 'mega', 'jumbo', 'giga'];
  dbDataSource: any;
  dataSource: any = [];
  displayedCol = [
    'service',
    'euro-inbound',
    'euro-return',
    'euro-roundtrip',
    'mega-inbound',
    'mega-return',
    'mega-roundtrip',
    'giga-inbound',
    'giga-return',
    'giga-roundtrip',
  ]; //'jumbo-inbound','jumbo-return','jumbo-round trip', 'giga-inbound','giga-return','giga-round trip'
  destinCol: string[] = [];
  rateTypeMapping: any = {};
  selectTruckType: string[] = [];

  @Input() rateId: number = 0;
  @Input() name: string = 'fixed ftl Table';
  @Input() orderId: number = 0;
  @Input() rateChange: number = 0;
  userData: any;
  @Input() operation = 'add';
  rateRatio: number = 0;
  private destroy$: Subject<boolean> = new Subject<boolean>();

  constructor(
    private httpService: HttpService,
    private dialog: MatDialog,
    public appService: AppService,
    private tableService: TableService
  ) {
    this.deleteIconUpdate();
    let userData = sessionStorage.getItem('user-data');
    this.userData = userData ? JSON.parse(userData) : null;
    // this.appService.matrixDataEmit.subscribe((evt:any) =>{
    //   if(evt.type== 43){
    //     this.rateId = evt.id;
    //     this.getTableData();
    //   }
    // })
    this.appService.fixedRateChangeSub?.unsubscribe();
    this.appService.fixedRateChangeSub = this.appService.applyCahngeEmitForFixed
      .pipe(takeUntil(this.destroy$))
      .subscribe((evt: any) => {
        // if(this.appService.rateTableList[this.appService.selectedItem]?.RateTableTypeID === 43){
        this.rateRatio = evt;
        this.onCalculateRatio();
        // }
      });
  }

  deleteIconUpdate() {
    this.destinCol = [];
    this.displayedCol.forEach((col) => {
      if (['service'].includes(col)) {
        if (!this.destinCol.includes('Distance'))
          this.destinCol.push('Distance');
      } else {
        if (!this.destinCol.includes(col.split('-')[0])) {
          this.destinCol.push(col.split('-')[0]);
          this.destinCol.push(`${col.split('-')[0]}-del`);
        }
      }
    });
    const sortedArray = this.destinCol.sort((a, b) => {
      const indexA = this.truckType.indexOf(a.split('-')[0]);
      const indexB = this.truckType.indexOf(b.split('-')[0]);

      return indexA - indexB;
    });
    this.destinCol = sortedArray;
    this.selectTruckType = this.truckType.filter(
      (value) => !this.destinCol.includes(value)
    );

    let outputOrder = [];
    for (let i = 0; i < this.destinCol.length; i++) {
      if (this.destinCol[i] === 'Distance') {
        outputOrder.push('service');
      } else if (this.destinCol[i].includes('del')) {
        let k = this.destinCol[i].split('-')[0];
        outputOrder.push(k + '-inbound', k + '-return', k + '-roundtrip');
      }
    }
    this.displayedCol = outputOrder;
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['rateId']?.currentValue) {
      this.rateId = changes['rateId'].currentValue;
    }
    if (changes['name']?.currentValue) {
      this.name = changes['name'].currentValue;
    }
    if (changes['operation']?.currentValue) {
      this.operation = changes['operation'].currentValue;
    }
    if (changes['orderId']?.currentValue) {
      this.orderId = changes['orderId'].currentValue;
    }
    if (changes['rateChange']?.currentValue) {
      this.rateRatio = changes['rateChange'].currentValue;
      this.onCalculateRatio();
    }
    this.getTableData();
    this.getCountryList();
  }

  getCountryList() {
    this.appService.isLoading = true;
    this.httpService.getCountryList().subscribe((res: any) => {
      this.appService.isLoading = false;
      if (res) {
        this.appService.countryListArr = res;
      }
    });
  }

  getTableData() {
    // alert()
    if (this.appService.rateBackUpData[this.appService.selectedItem]) {
      this.dbDataSource =
        this.appService.rateBackUpData[this.appService.selectedItem];
      let res = this.appService.rateDateSource[this.appService.selectedItem];

      let getCol = Object.keys(this.dbDataSource[0]);
      // getCol = ['from','to'].concat(getCol)
      this.displayedCol = getCol.filter((i: any) => i !== 'distance');
      this.deleteIconUpdate();

      let mautCountry = res.FixedFTLCountryID?.split(',');
      let mautCountryCost: any = ('' + res.FixedFTLMautCost)?.split(',');
      // if(this.rateId === 0){
      // mautCountryCost =[];
      // mautCountryCost = Array.from({length: mautCountry.length}).fill(0);
      // }

      let mautOutArr = [];

      if (mautCountry && mautCountry.length > 0) {
        mautOutArr = mautCountry.map((item: any, index: any) => ({
          country: this.appService.countryListArr.find(
            (i: any) => i.CountryID === +item
          )?.CountryName,
          rate: '' + mautCountryCost[index],
        }));
      }
      //
      this.appService.mautCostEmit.emit(mautOutArr);
      let additionalCosts = ('' + res.FixedFTLAdditionalCost)?.split(',');
      let additionalCostItems = res.FixedFTLAdditionalCostItem?.split(',');
      let costOutarr = [];
      // if(this.rateId !== 0){
      if (additionalCostItems && additionalCostItems.length > 0) {
        costOutarr = additionalCostItems.map((item: any, index: any) => ({
          charge: item,
          rate: additionalCosts[index],
        }));
      }
      this.appService.additionalCostEmit.emit(costOutarr);
      this.appService.exportConversionEmitter.emit({
        data: this.dbDataSource,
        type: 'fixed',
      });
      let obj = {
        data: this.dbDataSource,
        type: 'fixed',
        maut: mautOutArr,
        charge: costOutarr,
      };
      // this.appService.exportPDFTableList[this.appService.selectedItem] = obj
      return;
    }

    this.appService.isLoading = true;
    this.httpService.getFixedFTLTable(this.rateId).subscribe((res: any) => {
      this.appService.isLoading = false;
      if (res) {
        this.dbExcelDataFormat(res);
      }
    });
  }

  dbExcelDataFormat(res: any) {
    this.rateTypeMapping = {};
    // Step 1: Collect all unique rate types
    const uniqueRateTypes = new Set();
    res.forEach((obj: any) => {
      uniqueRateTypes.add(obj.TrailerRateType);
    });

    // Step 2: Map rate types to keys
    uniqueRateTypes?.forEach((rateType: any) => {
      let key = rateType
        .toLowerCase()
        .replace(/ - /g, '-')
        .replace(/ km rate/g, '')
        .replace(/ /g, '-');

      // Perform specific replacements
      key = key
        .replace('single-trip-inbound', 'inbound')
        .replace('single-trip-return', 'return')
        .replace('round-trip', 'roundtrip');
      this.rateTypeMapping[rateType] = key;
      this.displayedCol = ['service'].concat(
        Object.values(this.rateTypeMapping)
      );
      this.selectTruckType = this.truckType.filter(
        (value) =>
          !Object.values(this.rateTypeMapping).some((objValue: any) =>
            objValue.includes(value)
          )
      );
      this.deleteIconUpdate();
    });

    let mautData: any;
    mautData = res[0]?.MautCountry
      ? this.appService.onMautcountry(
          res[0]?.MautCountryCost,
          res[0].MautCountry
        )
      : { cost: null, item: null };
    this.appService.rateDateSource[
      this.appService.selectedItem
    ].FixedFTLMautCost = mautData.cost;
    this.appService.rateDateSource[
      this.appService.selectedItem
    ].FixedFTLCountryID = mautData.item;

    const updatedArray = res.map((obj: any) => {
      const {
        Distance,
        TrailerRateType,
        FTLMatrixCost,
        AdditionalCostItem,
        AdditionalCost,
        MautCountryCost,
        ...rest
      } = obj;
      return {
        FixedFTLDistance: Distance,
        FixedFTLTrailerRateType: TrailerRateType,
        FixedFTLCost: FTLMatrixCost,
        FixedFTLAdditionalCostItem: AdditionalCostItem,
        FixedFTLAdditionalCost: AdditionalCost,
        FixedFTLMautCost: mautData.cost,
        FixedFTLCountryID: mautData.item,
        ...rest,
      };
    });

    this.appService.setRateTableData(updatedArray, this.orderId, 'fixed');
    const transformedArray = res.reduce((acc: any, obj: any) => {
      const distance = obj.Distance;
      // const key = `${weightRange[0]}-${weightRange[1]}`;

      // Initialize the object with dynamic rate types if it doesn't exist
      if (!acc[distance]) {
        acc[distance] = {
          distance: distance,
          service: obj.Service,
          // orderId: FixedFTLMatrixID
        };
        uniqueRateTypes.forEach((rateType: any) => {
          acc[distance][this.rateTypeMapping[rateType]] = 0;
        });
      }

      const rateTypeKey: any = this.rateTypeMapping[obj.TrailerRateType];
      if (rateTypeKey) {
        acc[distance][rateTypeKey] = obj.FTLMatrixCost;
      }
      return acc;
    }, {});

    let finalArray = Object.values(transformedArray);
    this.dbDataSource = finalArray;
    this.appService.rateBackUpData[this.appService.selectedItem] =
      this.dbDataSource;
    if (!res[0]) {
      return;
    }
    // calculate addition cost
    if (res.length === 0) {
      return;
    }

    this.onAdditionCost(res[0]);
    // calculate maut cost
    this.onMautCalculation(res[0]);
    this.appService.exportConversionEmitter.emit({
      data: this.dbDataSource,
      type: 'fixed',
    });
  }

  onExportdata() {
    let arr = [{ displayName: 'Service', name: 'service', order: 1 }];
    this.destinCol
      .filter((item: any) => item.includes('-del'))
      .map((item: any) => {
        let str = item.split('-')[0];
        let count = arr.length;
        arr.push({
          displayName: `${
            str.toUpperCase() + ' - SINGLE TRIP INBOUND km rate'
          }`,
          name: `${str}-inbound`,
          order: count + 1,
        });
        arr.push({
          displayName: `${str.toUpperCase() + ' - SINGLE TRIP RETURN km rate'}`,
          name: `${str}-return`,
          order: count + 1,
        });
        arr.push({
          displayName: `${str.toUpperCase() + ' - ROUNDTRIP km rate'}`,
          name: `${str}-roundtrip`,
          order: count + 1,
        });
      });
    this.tableService.exportToExcel(this.dbDataSource, arr, this.name);
  }

  onAdditionCost(res: any) {
    let additionalCosts = null;
    additionalCosts =
      this.rateId === 0 ? '' : ('' + res.AdditionalCost)?.split(',');
    let additionalCostItems =
      this.rateId === 0 ? '' : res.AdditionalCostItem?.split(',');
    let costOutarr = [];
    // if(this.rateId !== 0){
    if (additionalCostItems && additionalCostItems.length > 0) {
      costOutarr = additionalCostItems.map((item: any, index: any) => ({
        charge: item,
        rate: +additionalCosts[index],
      }));
    }
    this.appService.additionalCostEmit.emit(costOutarr);
  }

  onMautCalculation(res: any) {
    let mautCountry = res.MautCountry?.split(',');
    let mautCountryCost: any = ('' + res.MautCountryCost)?.split(',');
    if (this.rateId === 0) {
      mautCountryCost = [];
      mautCountryCost = Array.from({ length: mautCountry.length }).fill(0);
    }

    let mautOutArr = [];

    if (mautCountry && mautCountry.length > 0) {
      mautOutArr = mautCountry.map((item: any, index: any) => ({
        country: item,
        rate: mautCountryCost[index],
      }));
    }
    this.appService.mautCostEmit.emit(mautOutArr);
  }

  getColspan(i: any) {
    if (i === 'Distance') return 1;
    if (i.split('-')[1]) return 1;
    return 2;
  }

  onValueCahnge(val: any, e: any, no: number) {
    this.appService.onRAvalueChanged = true;
    let cost: number = val.value;
    this.dbDataSource[no][e] = Number(cost);
    this.appService.rateBackUpData[this.appService.selectedItem] =
      this.dbDataSource;
    this.onSave();
  }

  getKeyByValue(
    object: { [key: string]: string },
    value: string
  ): string | undefined {
    return Object.keys(object).find((key) => object[key] === value);
  }

  onSrviceCall(val: any, e: any, no: number) {
    this.appService.onRAvalueChanged = true;
    // this.appService.rateBackUpData[this.appService.selectedItem] = e.value
    // console.log("eeeee",e, this.appService.rateDateSource[this.appService.selectedItem], this.dbDataSource, this.appService.rateBackUpData[this.appService.selectedItem]);
    this.dbDataSource[no]['service'] = val.value;
    this.appService.rateBackUpData[this.appService.selectedItem] =
      this.dbDataSource;

    // this.appService.updateDataToDB();
    this.onSave();
    /* commenting this code for service 14 span to 14 rows service udpate
    this.appService.rateDateSource[this.appService.selectedItem].Service = val.value;
    
    */
  }

  formatElementData(val: any) {
    return val != null ? '' + Number(val).toFixed(2) : '';
  }

  onCalculateRatio() {
    let truckList = this.truckType.filter(
      (type: string) => !this.selectTruckType.includes(type)
    );
    this.dbDataSource.forEach((obj: any) => {
      truckList.forEach((i: any) => {
        if (
          obj[i + '-inbound'] !== null ||
          obj[i + '-return'] !== null ||
          obj[i + '-roundtrip'] !== null
        ) {
          obj[i + '-inbound'] =
            Number(obj[i + '-inbound']) === 0
              ? 0
              : +(
                  Number(obj[i + '-inbound']) +
                  (Number(obj[i + '-inbound']) * this.rateRatio) / 100
                ).toFixed(2);
          obj[i + '-return'] =
            Number(obj[i + '-return']) === 0
              ? 0
              : +(
                  Number(obj[i + '-return']) +
                  (Number(obj[i + '-return']) * this.rateRatio) / 100
                ).toFixed(2);
          obj[i + '-roundtrip'] =
            Number(obj[i + '-roundtrip']) === 0
              ? 0
              : +(
                  Number(obj[i + '-roundtrip']) +
                  (Number(obj[i + '-roundtrip']) * this.rateRatio) / 100
                ).toFixed(2);

          if (this.rateRatio < 0) {
            obj[i + '-inbound'] = Math.max(obj[i + '-inbound'], 0);
            obj[i + '-return'] = Math.max(obj[i + '-return'], 0);
            obj[i + '-roundtrip'] = Math.max(obj[i + '-roundtrip'], 0);
          }
        }
      });
    });
    this.onSave();
  }

  onSave() {
    this.updateRateTypeMapping();
    let getData = sessionStorage.getItem('user-data');
    let userData = getData ? JSON.parse(getData) : null;
    const originalArray = this.dbDataSource.flatMap((obj: any) => {
      const { service, distance, ...weights } = obj;
      return Object.entries(weights).map(([weightRange, cost]) => ({
        FixedFTLDistance: `${distance}`,
        Service: `${service}`,
        FixedFTLTrailerRateType: this.getKeyByValue(
          this.rateTypeMapping,
          weightRange
        ),
        FixedFTLCost: cost,
      }));
    });

    this.appService.setRateTableData(originalArray, this.orderId, 'fixed');
    this.appService.exportConversionEmitter.emit({
      data: this.dbDataSource,
      type: 'fixed',
    });
  }

  dropDownSelct() {
    const dropDownElement = document.getElementById('fixed-drop-down');
    if (dropDownElement) {
      if (dropDownElement.style.display === 'block') {
        dropDownElement.style.display = 'none'; // If it's "block", make it "none"
      } else {
        dropDownElement.style.display = 'block'; // If it's "none" or anything else, make it "block"
      }
    }
  }

  onAddTrailer(i: string) {
    this.appService.onRAvalueChanged = true;
    if (
      this.displayedCol.includes(
        i + '-inbound' || i + '-return' || i + '-roundtrip'
      )
    ) {
      this.httpService.openSnackBar('Please Fill the Empty Trailer Value');
      return;
    }
    const dropDownElement = document.getElementById('fixed-drop-down');
    if (dropDownElement) {
      dropDownElement.style.display = 'none';
    }
    this.displayedCol.push(i + '-inbound', i + '-return', i + '-roundtrip');
    this.destinCol.push(i, i + '-del');

    this.dbDataSource = this.dbDataSource.map((item: any) => ({
      ...item,
      [i + '-inbound']: null,
      [i + '-return']: null,
      [i + '-roundtrip']: null,
    }));
    this.dbDataSource = [...this.dbDataSource];
    this.rateTypeMapping[
      `${i.toUpperCase() + ' - SINGLE TRIP INBOUND km rate'}`
    ] = `${i}-inbound`;
    this.rateTypeMapping[
      `${i.toUpperCase() + ' - SINGLE TRIP RETURN km rate'}`
    ] = `${i}-return`;
    this.rateTypeMapping[
      `${i.toUpperCase() + ' - ROUNDTRIP km rate'}`
    ] = `${i}-roundtrip`;
    this.appService.rateBackUpData[this.appService.selectedItem] =
      this.dbDataSource;
    this.selectTruckType = this.selectTruckType.filter((value) => value !== i);
    this.onSave();
  }

  updateRateTypeMapping() {
    let test: any = [];
    this.destinCol
      .filter((item: any) => item.includes('-del'))
      .map((item: any) => {
        let str = item.split('-')[0];
        test[
          `${str.toUpperCase() + ' - SINGLE TRIP INBOUND km rate'}`
        ] = `${str}-inbound`;
        (test[
          `${str.toUpperCase() + ' - SINGLE TRIP RETURN km rate'}`
        ] = `${str}-return`),
          (test[
            `${str.toUpperCase() + ' - ROUNDTRIP km rate'}`
          ] = `${str}-roundtrip`);
      });
    this.rateTypeMapping = test;
  }

  onDeleteTrailer(i: any) {
    let trailer = i.split('-')[0];
    this.selectTruckType.unshift(trailer);
    const dialogRef = this.dialog.open(DeleteWarningComponent, {
      disableClose: false,
      data: {
        header: 'Delete Fixed FTL Trailer',
        msg: `Are you sure you want to delete ${trailer.toUpperCase()} Trailer?`,
      },
    });
    dialogRef.afterClosed().subscribe((evt: any) => {
      if (evt.operation === 'confirm') {
        this.appService.onRAvalueChanged = true;
        let updatedData: any = this.dbDataSource.map((item: any) => {
          const {
            [(trailer + '-return') as string]: _,
            [(trailer + '-inbound') as string]: __,
            [(trailer + '-roundtrip') as string]: ___,
            ...rest
          }: { [key: string]: any } = item;
          return rest;
        });
        this.dbDataSource = [...updatedData];
        this.appService.rateBackUpData[this.appService.selectedItem] =
          this.dbDataSource;
        this.displayedCol = this.displayedCol.filter(
          (item) => !item.includes(trailer)
        );
        this.destinCol = this.destinCol.filter(
          (item) => !item.includes(trailer)
        );
        this.onSave();
      }
    });
  }
}
